import { Authority } from '@/shared/security/authority';

const MaterialRequestAdmin = () => import('@/entities/material-request-delivery/admin/admin.vue');
const MaterialRequestCarts = () => import('@/entities/material-request-delivery/carts/carts.vue');
const MaterialRequestDeliveryScreen = () => import('@/entities/material-request-delivery/delivery/delivery.vue');

export default [
  {
    path: '/material-request',
    name: 'material-request-admin',
    component: MaterialRequestAdmin,
    meta: { authorities: [Authority.STOCK_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/material-request/cart',
    name: 'material-request-carts',
    component: MaterialRequestCarts,
    meta: { authorities: [Authority.STOCK_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/material-request/delivery/:cartId',
    name: 'material-request-delivery',
    component: MaterialRequestDeliveryScreen,
    meta: { authorities: [Authority.STOCK_ADMIN, Authority.ADMIN], fullscreen: true },
  },
];
